export const ok = 1000;
export const entityAlreadyExists = 2601;
